import { render } from "./EditAlaUnePage.vue?vue&type=template&id=3c6fce5b&ts=true"
import script from "./EditAlaUnePage.vue?vue&type=script&lang=ts"
export * from "./EditAlaUnePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__